module.exports = __webpack_public_path__ + "static/img/dx_logo.828201c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dx_logo.png
// module id = epbP
// module chunks = 38